import React from 'react';
import cn from 'classnames';
import { Text } from '@alfalab/core-components-typography/esm';
import { StepBar } from './components/step-bar/Component.js';

var defaultColors = {"bar":"stepped-progress-bar__bar_bvrfo","description":"stepped-progress-bar__description_bvrfo"};
require('./default.css')

var styles = {"component":"stepped-progress-bar__component_1w680","stepsContainer":"stepped-progress-bar__stepsContainer_1w680","description":"stepped-progress-bar__description_1w680"};
require('./index.css')

var invertedColors = {"bar":"stepped-progress-bar__bar_1upnv","description":"stepped-progress-bar__description_1upnv"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var SteppedProgressBar = function (_a) {
    var maxStep = _a.maxStep, description = _a.description, _b = _a.step, step = _b === void 0 ? 0 : _b, view = _a.view, dataTestId = _a.dataTestId, _c = _a.colors, colors = _c === void 0 ? 'default' : _c, className = _a.className;
    var validMaxSteps = maxStep <= 0 ? 1 : maxStep;
    var isViewString = typeof view === 'string';
    return (React.createElement("div", { className: cn(styles.component, className), "data-test-id": dataTestId },
        React.createElement("div", { className: styles.stepsContainer }, Array.from(Array(validMaxSteps), function (_, index) { return (React.createElement(StepBar, { key: index, isDone: index < step, view: (isViewString ? view : view === null || view === void 0 ? void 0 : view[index]), classNameStep: colorStyles[colors].bar })); })),
        description && (React.createElement(Text, { tag: 'div', className: cn(styles.description, colorStyles[colors].description), view: 'primary-small' },
            "\u0428\u0430\u0433 ",
            step,
            " \u0438\u0437 ",
            maxStep,
            ": ",
            description))));
};

export { SteppedProgressBar };
